import React, { useMemo } from 'react';
import '../SelectedHistory.scss';
import { observer } from 'mobx-react-lite';
import { tableBetHistoryStore, useTranslation } from '@pascal/pascal-core';
import { BANKER_CARD } from '../../../enums/cardOwner';
import {
  BANKER_CARDS_BOX,
  CARDS,
  CARDS_BOX,
  CARDS_TYPE,
  HORIZONTAL_CARDS_INDEX,
} from '../../../enums/cardTypes';
import {
  BET_HISTORY_WIN_TYPE_VIEW,
  ROUND_BET_TYPE_VIEW,
  ROUND_WIN_TYPE_VIEW,
} from '../../../enums/betTypesEnum';
import { BET_HISTORY } from '../../../enums/constants';
import { useIdsGenerator } from '../../../hooks/useIdsGenerator';
import { cardsStore } from '../../../store/cardsStore';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { selectedCardType } = cardsStore;
  const { data: thirdStepData } = thirdStep;
  const t = useTranslation();
  const cardBoxIds = useIdsGenerator(CARDS_BOX);
  const bankerCardBoxIds = useIdsGenerator(BANKER_CARDS_BOX);

  const cardsByOwner = useMemo(() => {
    return thirdStepData?.roundData?.cards.reduce(
      (acc, cur) => {
        if (cur.owner === BANKER_CARD && cur.card !== CARDS.CUTTING_CARD) {
          acc.banker.push(cur);
        } else if (cur.card !== CARDS.CUTTING_CARD) {
          acc.player.push(cur);
        }
        return acc;
      },
      {
        player: [],
        banker: [],
      }
    );
  }, [thirdStepData]);

  if (!thirdStepData.roundData) {
    return null;
  }

  return (
    <div className='baccarat-bet-history-wrp'>
      <div className='baccarat-history-wrp-items'>
        <p className='baccarat-history-wrp-items-player'>
          {t(ROUND_WIN_TYPE_VIEW[ROUND_BET_TYPE_VIEW.PLAYER])}
        </p>
        <p className='baccarat-history-wrp-items-player'>
          {t(ROUND_WIN_TYPE_VIEW[ROUND_BET_TYPE_VIEW.BANKER])}
        </p>
        <p className='baccarat-history-wrp-items-player'>{t(BET_HISTORY.RESULT)}</p>
      </div>
      <div className='baccarat-history-card-wrp'>
        <div className='baccarat-history-card-wrp-items'>
          <div className='table-cards-cl left-cl'>
            {CARDS_BOX.map((item, index) => {
              const card = cardsByOwner.player[index];
              return (
                <div
                  className={`cards ${index === HORIZONTAL_CARDS_INDEX ? 'horizontal' : ''}`}
                  key={cardBoxIds[index]}
                >
                  {card && (
                    <div className={`card-holder ${CARDS_TYPE[card.card]} ${selectedCardType}`}>
                      <div className='card-holder-inner' />
                    </div>
                  )}
                </div>
              );
            })}
            <div className='history-cards-number'>{thirdStepData.roundData.playerTotalPoint}</div>
          </div>
        </div>

        <div className='baccarat-history-card-wrp-items'>
          <div className='table-cards-cl right-cl'>
            {BANKER_CARDS_BOX.map((item, index) => {
              const card = cardsByOwner.banker[1 - index];
              return (
                <div
                  className={`cards ${index === HORIZONTAL_CARDS_INDEX ? 'horizontal' : ''}`}
                  key={bankerCardBoxIds[index]}
                >
                  {card && (
                    <div className={`card-holder ${CARDS_TYPE[card.card]} ${selectedCardType}`}>
                      <div className='card-holder-inner' />
                    </div>
                  )}
                </div>
              );
            })}
            <div className='cards horizontal'>
              {cardsByOwner.banker[HORIZONTAL_CARDS_INDEX] && (
                <div
                  className={`card-holder ${
                    CARDS_TYPE[cardsByOwner.banker[HORIZONTAL_CARDS_INDEX].card]
                  }`}
                >
                  <div className='card-holder-inner' />
                </div>
              )}
            </div>
            <div className='history-cards-number'>{thirdStepData.roundData.bankerTotalPoint}</div>
          </div>
        </div>

        <div className='baccarat-history-card-wrp-items'>
          <p className='history-player-word'>
            {t(ROUND_WIN_TYPE_VIEW[thirdStepData.roundData.winType])}
          </p>
        </div>
      </div>
      <div className='baccarat-history-wrp-items'>
        <p className='baccarat-history-wrp-items-player'>{t(BET_HISTORY.BET_TYPE)}</p>
        <p className='baccarat-history-wrp-items-player'>{t(BET_HISTORY.BET)}</p>
        <p className='baccarat-history-wrp-items-player'>{t(BET_HISTORY.WIN)}</p>
      </div>
      {thirdStepData.additionalParams.map(({ type, amount, winAmount }) => (
        <div className='baccarat-history-wrp-items-amount' key={type}>
          <p className='baccarat-history-wrp-items-player'>{t(BET_HISTORY_WIN_TYPE_VIEW[type])}</p>
          <p className='baccarat-history-wrp-items-player'>
            {amount} {thirdStepData.freeBetId ? `(${t('FREE_BET')})` : ''}
          </p>
          <p className='baccarat-history-wrp-items-player'>{winAmount}</p>
        </div>
      ))}

      <div className='baccarat-history-wrp-items-amount total'>
        <p className='baccarat-history-wrp-items-player'>{t(BET_HISTORY.TOTAL)}</p>
        <p className='baccarat-history-wrp-items-player'>{thirdStepData.amount}</p>
        <p className='baccarat-history-wrp-items-player'>{thirdStepData.winAmount}</p>
      </div>
    </div>
  );
});
